import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import EmployeeType from 'types/EmployeeType';
import ResponsiveImage from 'components/ResponsiveImage';
import Link, { LINK_BEHAVIORS, LINK_SIZES, LINK_THEMES } from 'components/Link';
import LinkButton, { LINK_BUTTON_THEMES } from 'components/LinkButton';
import Modal, { modalType } from 'components/Modal';
import LatestChroniclesBlock from 'components/LatestChroniclesBlock';
import { breakpoints } from 'js/breakpoints';

import * as css from './EmployeeModal.scss';

class EmployeeModal extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    ...EmployeeType,
  };
  constructor() {
    super();

    this.state = {
      textExpandedInMobile: false,
    };

    this._expandTextInMobile = this._expandTextInMobile.bind(this);
  }

  _expandTextInMobile() {
    this.setState({
      textExpandedInMobile: true,
    });
  }

  render() {
    const {
      image,
      name,
      title,
      intro,
      phone,
      phoneFormatted,
      secondaryPhone,
      secondaryPhoneFormatted,
      email,
      modalLabels,
      onClose,
      latestChronicles,
    } = this.props;

    const { textExpandedInMobile } = this.state;

    return (
      <Modal
        hasImage={image.src && !!image.src}
        labels={modalLabels}
        onClose={onClose}
        type={modalType.employee}
      >
        {image && image.src && (
          <div className={css.imageContainer}>
            <ResponsiveImage
              {...image}
              fluid
              loading="lazy"
              className={css.image}
              sources={[
                {
                  width: 390,
                  height: 300,
                  media: breakpoints.xs,
                },
                {
                  width: 920,
                  height: 460,
                  media: breakpoints.m,
                },
                {
                  width: 680,
                  height: 680,
                  media: breakpoints.l,
                },
              ]}
            />
            <Link
              url={image.url}
              text={modalLabels.downloadImage}
              theme={LINK_THEMES.lightTotal}
              size={LINK_SIZES.small}
              openInNewTab
              className={css.downloadImageLink}
            />
          </div>
        )}
        <div
          className={cn(css.content, {
            [css.expandedInMobile]: textExpandedInMobile,
          })}
        >
          <div>
            <header>
              <h2 className="h1">{name}</h2>
            </header>
            <h2>{title}</h2>
            <div
              className={cn(css.intro, 'wysiwyg')}
              dangerouslySetInnerHTML={{ __html: intro }}
            />
          </div>
          <div className={css.contacts}>
            {email && (
              <div className={css.contact}>
                <h3 className={css.contactLabel}>{modalLabels.email}</h3>
                <Link
                  url={`mailto:${email}`}
                  text={email}
                  behavior={LINK_BEHAVIORS.text}
                />
              </div>
            )}
            {phone && (
              <div className={css.contact}>
                <h3 className={css.contactLabel}>{modalLabels.phone}</h3>
                <Link
                  url={`tel:${phoneFormatted}`}
                  text={phone}
                  behavior={LINK_BEHAVIORS.text}
                />
                {secondaryPhone && (
                  <div>
                    <Link
                      url={`tel:${secondaryPhoneFormatted}`}
                      text={secondaryPhone}
                      behavior={LINK_BEHAVIORS.text}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
          <div>
            <LatestChroniclesBlock {...latestChronicles} theme="short-view" />
          </div>
          {!textExpandedInMobile && (
            <div className={css.expandButtonContainer}>
              <LinkButton
                text={modalLabels.showMore}
                theme={LINK_BUTTON_THEMES.outlineDark}
                fullWidth
                onClick={this._expandTextInMobile}
              />
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

export default EmployeeModal;
